import React from 'react';
// Native MUI Components
import { 
  Card, 
  CardContent, 
  CardHeader, 
  Typography, 
  TextField, 
  Stack,
  Grid
} from '@mui/material';
import { useI18n } from '@/hooks/useI18n';

interface AgeCategoryCardProps {
  title: string;
  emoji: string;
  label: string;
  min: number;
  max?: number;
  onLabelChange: (value: string) => void;
  onMinChange: (value: number) => void;
  onMaxChange?: (value: number) => void;
  showMaxField?: boolean;
}

const AgeCategoryCard: React.FC<AgeCategoryCardProps> = ({
  title,
  emoji,
  label,
  min,
  max,
  onLabelChange,
  onMinChange,
  onMaxChange,
  showMaxField = true
}) => {
  const { t } = useI18n();

  return (
    <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
      <Card sx={{ 
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      }}>
        <CardHeader
          title={
            <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {emoji} {title}
            </Typography>
          }
        />
        <CardContent sx={{ flexGrow: 1 }}>
          <Stack spacing={2}>
            <TextField
              label={t('skipass.ageCategory.categoryLabel')}
              value={label}
              onChange={(e) => onLabelChange(e.target.value)}
              placeholder={t('skipass.ageCategory.categoryPlaceholder', { title })}
              size="small"
              fullWidth
            />
            {showMaxField ? (
              <Grid container spacing={2}>
                <Grid size={6}>
                  <TextField
                    label={t('skipass.ageCategory.minAge')}
                    type="number"
                    inputProps={{ min: 0 }}
                    value={min}
                    onChange={(e) => onMinChange(parseInt(e.target.value))}
                    size="small"
                    fullWidth
                  />
                </Grid>
                <Grid size={6}>
                  <TextField
                    label={t('skipass.ageCategory.maxAge')}
                    type="number"
                    inputProps={{ min: 0 }}
                    value={max || 0}
                    onChange={(e) => onMaxChange?.(parseInt(e.target.value))}
                    size="small"
                    fullWidth
                  />
                </Grid>
              </Grid>
            ) : (
              <TextField
                label={t('skipass.ageCategory.minimumAge')}
                type="number"
                inputProps={{ min: 0 }}
                value={min}
                onChange={(e) => onMinChange(parseInt(e.target.value))}
                size="small"
                fullWidth
              />
            )}
          </Stack>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default AgeCategoryCard;
